export let partitionBy = f => xs =>
  xs.reduce((acc, x) => {
    let previousIndex = acc.length - 1
    let lastCluster = acc[previousIndex]

    let hasPrevious =
      lastCluster &&
      lastCluster[0]

    let isFirst = acc.length === 0

    let isFirstOfProp =
      hasPrevious &&
      f(lastCluster[0]) !== f(x)

    let isSimilarToPrevious =
      hasPrevious &&
      f(lastCluster[0]) === f(x)

    if (isFirst || isFirstOfProp) {
      acc.push([x])
    } else if (isSimilarToPrevious) {
      acc[previousIndex].push(x)
    }

    return acc
  }, [])
